import { render, staticRenderFns } from "./rwbjForm.vue?vue&type=template&id=27e0a3a0&scoped=true"
import script from "./rwbjForm.vue?vue&type=script&lang=js"
export * from "./rwbjForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0a3a0",
  null
  
)

export default component.exports